<h1>Manage Modifiers</h1>
<p>Search for a modifier or ingredient to manage its availability</p>

@if (modifiersToFilter) {
  <app-manage-item-filter
    [items]="modifiersToFilter"
    [filteredItems]="filteredModifiers"
    [pageName]="'Modifiers'"
    (filteredItemsEvent)="updateFilteredItems($event)">
  </app-manage-item-filter>
}

<div class="header-container">
  <div class="column col-1">Name</div>
  <div class="column col-2"><!-- placeholder for commerce item number --></div>
  <div class="column col-3">Location</div>
  <div class="column col-4">Availability</div>
</div>
<div class="modifier-container">
  @for (currentModifier of filteredModifiers; track currentModifier) {
    <div class="modifier">
      <div class="column col-1">{{ currentModifier.itemName }}</div>
      <div class="column col-2">{{ displayCommerceItemNumber(currentModifier) }}</div>
      <div class="column col-3">{{ currentModifier.productType }}</div>
      <div class="column col-4">
        <label class="availability-switch">
          <mat-slide-toggle
            [(ngModel)]="currentModifier.isAvailable"
            (change)="openAvailabilityDialog(currentModifier)"></mat-slide-toggle>
        </label>
      </div>
    </div>
  }
</div>
